import { useBreakpoint } from '@ocean/hooks'
import { HeaderBackground as HeaderBackgroundComponent } from 'components/headers/common'
import { createProductSheetBannerImageUrl } from 'modules/simulatorTrainings/common/api/simulatorTrainingService'
import bgDesktop from './assets/preview.jpg'
import bgMobile from './assets/preview_mobile.jpg'

type HeaderBackgroundProps = {
  id: string
}

const HeaderBackground: React.FC<HeaderBackgroundProps> = ({ id }) => {
  const isDesktop = useBreakpoint('sm')

  return (
    <HeaderBackgroundComponent
      imageUrl={createProductSheetBannerImageUrl(id)}
      defaultImageUrl={isDesktop ? bgDesktop : bgMobile}
    />
  )
}

export default HeaderBackground
